
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlH as ObiOwnShipControlHElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-h.js';
 
 
 

 
 export const ObiOwnShipControlH = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-h',
   elementClass: ObiOwnShipControlHElement,
   events: {
     
   }
  });
 
 